<template>
  <v-row no-gutters class="my-5">
    <v-col cols="12" sm="12" md="6">
      <!-- Tech-passport photos -->
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <h3>{{ $t('auto.label.techPassport') }} *</h3>
          <v-label class="mb-1">{{
            $t('auto.label.techPassportHint')
          }}</v-label>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" sm="6" class="img-uploader">
          <image-uploader-new
            ref="techPassport1"
            :photo.sync="credentials.techPassport1"
            :rules="rules.techPassport1"
            :download="$can('auto_download_photo')"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6" class="img-uploader">
          <image-uploader-new
            ref="techPassport2"
            :photo.sync="credentials.techPassport2"
            :rules="rules.techPassport2"
            :download="$can('auto_download_photo')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-label>
            {{ $t('auto.techPassport.requiredHint') }}
          </v-label>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <!-- Promo photos -->
      <v-row justify="center">
        <v-col cols="10">
          <v-checkbox
            color="primary"
            v-model="credentials.isPromo"
            :label="$t('auto.fields.promoCheckbox')"
            :input-value="credentials.isPromo"
            class="mt-0"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6" md="6" class="img-uploader">
          <image-uploader-new
            ref="promoPhoto"
            :disabled="!credentials.isPromo"
            :photo.sync="credentials.promoPhoto"
            :rules="rules.promoPhoto"
            :download="$can('auto_download_photo')"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="10">
          <v-label>{{ $t('auto.hints.promoPhotoLabel') }}</v-label
          ><br />
          <v-label>{{ $t('auto.hints.promoPhotoText') }}</v-label>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ImageUploaderNew from '@/components/shared/ImageUploader.vue';

export default {
  name: 'DocAndPromo',
  components: {
    ImageUploaderNew,
  },
  data() {
    return {
      credentials: {
        techPassport1: null,
        techPassport2: null,
        isPromo: false,
        promoPhoto: null,
      },
      rules: {
        techPassport1: [
          (v) => !!v || this.$t('common.fields.validation.photo.required'),
        ],
        techPassport2: [
          (v) => !!v || this.$t('common.fields.validation.photo.required'),
        ],
        promoPhoto: [
          (v) =>
            /* eslint-disable */
            !this.credentials.isPromo ||
            !!v ||
            this.$t('common.fields.validation.photo.required'),
          /* eslint-enable */
        ],
      },
    };
  },
  props: {
    techPassport: Object,
    promo: Object,
  },
  methods: {
    getComponentData() {
      const techPassport = {
        techPassport1: this.credentials.techPassport1,
        techPassport2: this.credentials.techPassport2,
      };
      const promo = {
        isPromo: this.credentials.isPromo,
        promoPhoto: this.credentials.promoPhoto,
      };
      this.$emit('update:techPassport', techPassport);
      this.$emit('update:promo', promo);
    },
    writeDataToFields(docData, promoData) {
      this.credentials.techPassport1 = docData.techPassport1;
      this.credentials.techPassport2 = docData.techPassport2;
      this.credentials.isPromo = promoData.isPromo;
      this.credentials.promoPhoto = promoData.promoPhoto;
    },
    validatePhotos() {
      let isValid = true;
      this.$children.forEach((element) => {
        /* eslint-disable */
        if (
          element.$options['_componentTag'] &&
          element.$options['_componentTag'] === 'image-uploader-new'
        ) {
          if (!element.validate()) {
            isValid = false;
          }
        }
      });
      return isValid;
      /* eslint-enable */
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 300;
}
.hint {
  color: #bababa;
}
.img-uploader {
  height: 220px;
}
</style>
